import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

/**
 * Logger sidetreff (path, seksjon, referrer, UTM, landing-flag, enhet-bredde).
 * - is_landing: første sidetreff i denne nettleser-tabs livstid
 * - referrer: kun ekstern referrer (intern navigasjon filtreres av backend)
 * - UTM-parametre leses fra URL og holdes i sessionStorage så de overlever videre navigasjon
 */
const SECTION_MAP = {
  "": "dashbord",
  "forum": "forum",
  "thread": "forum",
  "galleri": "galleri",
  "bilder": "galleri",
  "album": "galleri",
  "noveller": "noveller",
  "novelle": "noveller",
  "skapere": "skapere",
  "skaper": "skapere",
  "konkurranser": "konkurranser",
  "konkurranse": "konkurranser",
  "grupper": "grupper",
  "gruppe": "grupper",
  "annonser": "annonser",
  "annonse": "annonser",
  "soek": "soek",
  "sok": "soek",
  "search": "soek",
  "innstillinger": "innstillinger",
  "profil": "profil",
  "profile": "profil",
  "min-skaperside": "skapere",
  "meldinger": "meldinger",
  "varsler": "varsler",
  "admin": "admin",
  "bli-onlyfans-skaper": "coaching",
  "bli-skaper": "bli-skaper",
  "selger-verifisering": "selger-verifisering",
  "register": "register",
  "login": "login",
  "kontakt": "kontakt",
  "veyl": "veyl",
  "sladd": "veyl",
};

function readUtm() {
  // Les UTM fra URL eller fra sessionStorage (om de ble lagret før)
  try {
    const url = new URL(window.location.href);
    const fromUrl = {
      utm_source: url.searchParams.get("utm_source"),
      utm_campaign: url.searchParams.get("utm_campaign"),
      utm_medium: url.searchParams.get("utm_medium"),
      utm_content: url.searchParams.get("utm_content"),
    };
    if (fromUrl.utm_source) {
      sessionStorage.setItem("ne_utm", JSON.stringify(fromUrl));
      return fromUrl;
    }
    const stored = sessionStorage.getItem("ne_utm");
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}

export default function usePageViewTracker() {
  const loc = useLocation();
  const isFirstView = useRef(true);

  useEffect(() => {
    const seg = loc.pathname.split("/").filter(Boolean)[0] || "";
    const section = SECTION_MAP[seg] || "annet";

    let referrer = "";
    if (isFirstView.current) {
      // Bare ved første sidetreff – ekte ekstern referrer
      referrer = document.referrer || "";
    }
    const isLanding = isFirstView.current;
    isFirstView.current = false;

    const utm = readUtm();

    api.post("/page-view", {
      path: loc.pathname,
      section,
      referrer: referrer || null,
      is_landing: isLanding,
      screen_w: window.innerWidth || null,
      utm_source: utm.utm_source || null,
      utm_campaign: utm.utm_campaign || null,
      utm_medium: utm.utm_medium || null,
    }).catch(() => {});
  }, [loc.pathname]);
}
